/**
 * Search normalization for Persian text (patient names, quick search).
 * MUST stay identical to the SQL function `app.normalize_search` (migrations/0005_patients.sql);
 * an integration test compares both on the same inputs.
 *
 * - Arabic ي ى → Persian ی, Arabic ك → Persian ک, ة ۀ → ه, أ إ آ → ا
 * - zero-width non-joiner and no-break space → space; tatweel removed
 * - Persian and Arabic-Indic digits → Latin
 * - ASCII letters lower-cased (only ASCII, so the result never depends on a database locale);
 *   runs of ASCII whitespace collapsed; trimmed
 */
const FROM = 'يىكةۀأإآ‌ ۰۱۲۳۴۵۶۷۸۹٠١٢٣٤٥٦٧٨٩';
const TO = 'ییکههااا  01234567890123456789';
const MAP = new Map<string, string>(Array.from(FROM).map((c, i) => [c, Array.from(TO)[i] as string]));

export function normalizeSearchText(value: string): string {
  let out = '';
  for (const c of value) {
    if (c === 'ـ') continue; // tatweel
    out += MAP.get(c) ?? c;
  }
  return out
    .replace(/[A-Z]/g, (c) => c.toLowerCase())
    .replace(/[\t\n\v\f\r ]+/g, ' ')
    .trim();
}
